var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgZip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.429 1h12.137L22 7.168v14.457c0 .76-.64 1.375-1.429 1.375H3.43C2.64 23 2 22.385 2 21.625V2.375C2 1.615 2.64 1 3.429 1Z",
  fill: "#8963ED"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.98 7.188H17c-.788 0-1.428-.616-1.428-1.375V1.014l6.407 6.174Z",
  fill: "#602EE2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.676 17.445V18.5H6.559v-1.055h4.117Zm-.028-3.93L7.238 18.5h-.992v-.723l3.45-4.965h.952v.704Zm-.441-.703v1.06h-3.98v-1.06h3.98ZM12.758 12.813V18.5H11.39v-5.688h1.367ZM15.992 16.57h-1.414v-1.058h1.414a.979.979 0 0 0 .469-.098.595.595 0 0 0 .262-.27.888.888 0 0 0 .086-.394c0-.156-.03-.3-.086-.434a.7.7 0 0 0-.262-.32.804.804 0 0 0-.469-.125h-.898V18.5h-1.371v-5.688h2.27c.455 0 .847.084 1.175.25.33.167.585.396.762.688.177.29.265.62.265.992 0 .367-.088.688-.265.961a1.767 1.767 0 0 1-.762.64c-.328.152-.72.227-1.176.227Z",
  fill: "#fff"
})));
export default SvgZip;